import { IconStyles } from '../types'
import { CheckOutlineCustom } from './styles'

interface CheckOutlineProps extends IconStyles {
  onClick?: () => void
}
export const CheckOutLineIcon = ({
  onClick,
  cursor,
  marginBottom,
  marginLeft,
  marginRight,
  marginTop,
  colorIcon,
  disabled
}: CheckOutlineProps) => {
  return (
    <CheckOutlineCustom
      marginTop={marginTop}
      marginBottom={marginBottom}
      marginLeft={marginLeft}
      marginRight={marginRight}
      cursor={cursor}
      onClick={disabled ? null : onClick}
      disabled={disabled}
      colorIcon={colorIcon}
    />
  )
}
